import './style/baseStyle.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App/App';
const container = document.querySelector('[app-root]');
if (!container) throw new Error('no container found');
const root = createRoot(container);
root.render(<App></App>);